// extracted by mini-css-extract-plugin
export var cardIcon = "_bd-4";
export var checkboxCard = "_bd-0";
export var checkboxCardSelected = "_bd-3";
export var disabled = "_bd-1";
export var outerBorder = "_bd-2";
export var spacerMedium = "_bd-7";
export var spacerSmall = "_bd-6";
export var spacerXsmall = "_bd-5";